/* Boss Claws – adds a cart icon to the header, just before the hamburger menu (mobile) */
(function () {
  function init() {
    var container = document.querySelector('.nav-container');
    var menuBtn = document.querySelector('.mobile-menu-btn');
    if (!container || !menuBtn || document.getElementById('headerCartBtn')) return;

    // Group cart + hamburger on the right of the header
    var actions = document.createElement('div');
    actions.className = 'nav-actions';

    var cartLink = document.createElement('a');
    cartLink.id = 'headerCartBtn';
    cartLink.className = 'header-cart-btn';
    cartLink.href = '/cart';
    cartLink.setAttribute('aria-label', 'Open cart');
    cartLink.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>' +
      '<line x1="3" y1="6" x2="21" y2="6"></line>' +
      '<path d="M16 10a4 4 0 0 1-8 0"></path></svg>' +
      '<span class="header-cart-badge is-empty" id="headerCartCount">0</span>';

    container.appendChild(actions);
    actions.appendChild(cartLink);
    actions.appendChild(menuBtn);

    menuBtn.setAttribute('aria-label', 'Menu');
    menuBtn.setAttribute('aria-controls', 'navLinks');
    menuBtn.setAttribute('aria-expanded', 'false');

    // Keep the badge in sync with the existing #cartCount (updated by the theme's cart code)
    var badge = document.getElementById('headerCartCount');
    var source = document.getElementById('cartCount');
    var last = null;
    function sync() {
      var n = parseInt(source ? source.textContent : '0', 10) || 0;
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.classList.toggle('is-empty', n === 0);
      if (last !== null && n > last) {
        cartLink.classList.remove('bump');
        void cartLink.offsetWidth;
        cartLink.classList.add('bump');
      }
      last = n;
    }
    if (source) {
      new MutationObserver(sync).observe(source, { childList: true, characterData: true, subtree: true });
    }
    sync();

    // Hamburger <-> close icon, and close the menu when tapping outside it
    var navLinks = document.getElementById('navLinks');
    if (navLinks) {
      new MutationObserver(function () {
        var open = navLinks.classList.contains('active');
        menuBtn.textContent = open ? '\u2715' : '\u2630';
        menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }).observe(navLinks, { attributes: true, attributeFilter: ['class'] });

      document.addEventListener('click', function (e) {
        if (!navLinks.classList.contains('active')) return;
        if (navLinks.contains(e.target) || menuBtn.contains(e.target)) return;
        navLinks.classList.remove('active');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
